module.exports = PlayerCdn;


//////////////////
// WEBPACK FOOTER
// external "PlayerCdn"
// module id = CNbz
// module chunks = 1 2 3